import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-participants-dialog',
    templateUrl: './participants-dialog.component.html',
    styleUrls: ['./participants-dialog.component.scss'],
    standalone: false
})
export class ParticipantsDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public participants: any[]) {}

  getInitials(user: any): string {
    const first = user.firstname?.charAt(0) || '';
    const last = user.lastname?.charAt(0) || '';
    return (first + last).toUpperCase();
  }

  getAvatarColor(name: string): string {
  const colors = ['#3f51b5', '#e91e63', '#009688', '#ff9800'];
  return colors[name.length % colors.length];
}
}